<div class="box_default box_white rules-list">
    <div *ngIf="status == STATUS_DONE && rules.length > 0">
        <h3><span>ALL THE RULES</span></h3>
        <ul class="rules-ul">
            <!-- order first by name and then for active, on the reverse filter set mix the inactives (last order refine the previus)  -->
            <core-helpers-lists-one-action-list-item
                *ngFor="let rule of rules | sortByStringCi : 'name' : 'asc' | sortByActive"
                [title]="rule.name"
                [subtitle]="getDescription(rule.key)"
                [actionText]="rule.active? 'Deactivate' : 'Activate'"
                (actionClick)="rule.active? deactivate(rule) : activate(rule)"
                (titleClick)="onSelectRule(rule)"
                [type]="rule.active? '': 'inactive disabled'"
            ></core-helpers-lists-one-action-list-item>
        </ul>
    </div>
    <div class="loader">
        <div class="dimmed" [hidden]="status == STATUS_DONE || !access">
            <div class="dimmed_title"></div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
            </div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
            </div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
            </div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
            </div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
            </div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
        <!-- <core-helpers-box-loading [hidden]="status == STATUS_DONE || !access"></core-helpers-box-loading> -->
    </div>

</div>
<div class="rules-any" *ngIf="status == STATUS_DONE && rules.length == 0">
    <span>There are no rules saved.</span>
</div>
